var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-ringing-1--android-phone-mobile-device-smartphone-iphone-ringing-incoming-call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fill: "#ffffff",
    d: "M10.286 4.458a1.533 1.533 0 0 1 2.272 0.246c0.082 0.112 0.182 0.242 0.31 0.403a2.825 2.825 0 0 1 -0.004 3.516c-0.606 0.75 -1.241 1.508 -1.951 2.218s-1.468 1.345 -2.219 1.951a2.825 2.825 0 0 1 -3.515 0.005 12.49 12.49 0 0 0 -0.443 -0.34c-0.722 -0.527 -0.845 -1.516 -0.26 -2.193 0.267 -0.308 0.549 -0.607 0.827 -0.9a1.069 1.069 0 0 1 1.459 -0.074c0.11 0.094 0.24 0.21 0.444 0.401 1.168 -0.694 1.875 -1.41 2.557 -2.556 -0.194 -0.207 -0.31 -0.339 -0.405 -0.45a1.06 1.06 0 0 1 0.077 -1.452 33.1 33.1 0 0 1 0.851 -0.775Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3 (Stroke)",
    fill: "#ffffff80",
    fillRule: "evenodd",
    d: "M5.695 5.615a1.79 1.79 0 0 1 1.184 -0.41 0.75 0.75 0 1 0 0.035 -1.499 3.29 3.29 0 0 0 -2.172 0.751 3.29 3.29 0 0 0 -1.14 1.9 0.75 0.75 0 0 0 1.471 0.294 1.79 1.79 0 0 1 0.622 -1.036Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3 (Stroke)_2",
    fill: "#ffffff80",
    fillRule: "evenodd",
    d: "M3.715 3.261a4.983 4.983 0 0 1 3.293 -1.139 0.75 0.75 0 0 0 0.035 -1.5 6.483 6.483 0 0 0 -4.281 1.48A6.481 6.481 0 0 0 0.516 5.848a0.75 0.75 0 1 0 1.471 0.294 4.981 4.981 0 0 1 1.728 -2.88Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.e6519a885486c7958ec3f422515752c2.svg";
export { ForwardRef as ReactComponent };